module.exports = __webpack_public_path__ + "static/bar01_4_mobile-1fd9909461bb2469d71547e23e28d464.png";